import { render } from "./professionKnowledgeView.vue?vue&type=template&id=701a2ead"
import script from "./professionKnowledgeView.vue?vue&type=script&lang=js"
export * from "./professionKnowledgeView.vue?vue&type=script&lang=js"

import "./professionKnowledgeView.vue?vue&type=style&index=0&id=701a2ead&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__